Ext.define('WindowKategorieAddEdit', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.kategoria.capitalise(),
    width: 350,
    height: 350,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            items: [{
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyCls: "custom-body-form-panel",
                scrollable: 'y',
                defaults: {
                    labelWidth: 120
                },
                items: [{
                    id: this.cid + "nazwa",
                    name: "nazwa",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.nazwa,
                    allowBlank: false,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + 'type',
                    xtype: 'comboexd',
                    store: (Const.BASICFLAG || Const.STANDARDFLAG) ? TYP_KATEGORII_ONLY_KM : TYP_KATEGORII,
                    triggerAction: 'all',
                    resizable: false,
                    mode: "local",
                    editable: true,
                    allowBlank: false,
                    fieldLabel: Lang.tryb_pracy
                }, {
                    id: this.cid + "eiid",
                    name: "eiid",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.eiid,
                    allowBlank: true,
                    blankText: Lang.pole_nie_moze_byc_puste,
                    hidden: Const.BASICFLAG || Const.STANDARDFLAG
                }, {
                    id: this.cid + "opis",
                    name: "opis",
                    xtype: 'textareaexd',
                    fieldLabel: Lang.opis,
                    allowBlank: true,
                    blankText: Lang.pole_nie_moze_byc_puste
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            ui: 'btn-primary-s',
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            ui: 'btn-secondary-s',
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex('access.manage.kategorie')) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiektid = obiektid;
        this.obiekt = null;
        sendAjaxDataJsonRpcL("rest/kategorie/getObjectForEdit", {
            id: obiektid
        }, this, function (data) {
            if (data.status) {
                this.obiekt = data.data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                if (this.obiekt != null) {
                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                    Ext.getCmp(this.cid + "opis").setValue(this.obiekt.opis);
                    Ext.getCmp(this.cid + "eiid").setValue(this.obiekt.eiid);
                    Ext.getCmp(this.cid + "type").setValue(this.obiekt.type);
                } else {
                    Ext.getCmp(this.cid + "type").setValue2(TYP_KATEGORII[0][0]);
                }
            }
        });
    },
    saveOp: function () {
        if (!Ext.getCmp(this.cid + 'formpanel').form.isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        sendAjaxDataJsonRpcL("rest/kategorie/saveObject", {
            id: this.obiektid,
            nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
            opis: Ext.getCmp(this.cid + "opis").getValue(),
            eiid: Ext.getCmp(this.cid + "eiid").getValue(),
            type: Ext.getCmp(this.cid + "type").getValue2(),
            optlockversion: this.obiekt != null ? this.obiekt.optlockversion : null
        }, this, function (data) {
            if (data.status) {
                var data = data.data;
                this.fireEvent("wclose");
                this.closeOp();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    }
});

